// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-noho -> repli-training-noho -> noho
// Generated: 2026-09-10T15:14:07.077Z
// Counts: 6 design, 27 content, 14 slot group, 1 collection binding, 6 section, 0 style

export const designOverrides = {
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Open Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Open Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Open Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find Your New Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.follow_us_label": {
    "overrideType": "VALUE",
    "customValue": "<p>Follow Us On</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>IN <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-northwest-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find dog-friendly spaces at 35 Degrees North Apartment Homes. Enjoy expansive dog parks right in Northwest Oklahoma City.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-northwest-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Dog Friendly Apartments in NW Oklahoma City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thinking about calling <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title_fallback": {
    "overrideType": "VALUE",
    "customValue": "<h3>Schedule a Tour Today</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "featuredamenities.card1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resort-Style Saltwater Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-0539-732b-b288-bbc96975f3d9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resort-style swimming pool with cabanas and lounge chairs, surrounded by apartment buildings."
      }
    }
  },
  "featuredamenities.card2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness & Yoga Studio"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-da8f-7082-a35e-b151d3951115.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern gym with a large fan, exercise equipment, and a vibrant palm tree mural."
      }
    }
  },
  "featuredamenities.card3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Club Lounge with Billiards"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-e242-7066-9f45-10e929aeaf21.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Billiards table and shuffleboard in a modern lounge area with a bar and seating."
      }
    }
  },
  "featuredamenities.card4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pet Spa & Grooming Station"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-c87f-7033-9d21-76e29453fd74.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Pet spa with grooming station and dog dryer."
      }
    }
  },
  "featuredamenities.card5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor Fire Pits"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-16ba-763c-9f88-24742206b705.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor patio area with blue adirondack chairs and a fire pit in front of an apartment building."
      }
    }
  },
  "featuredamenities.card6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard Grilling Stations"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-b784-7147-a56c-ce4a8eef26a8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor kitchen area with a Big Green Egg grill and built-in barbecue."
      }
    }
  },
  "featuredamenities.card7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Game Room"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a070c1-e3a1-719f-931b-15b1d9db5c75.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Game room with skeeball and pinball machines and abstract art."
      }
    }
  },
  "featuredamenities.card8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard with Water Feature"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03518-1081-7789-8657-c9560b8e88ea.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard with fountain and seating areas at a modern apartment building."
      }
    }
  },
  "footer.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "text": {
        "type": "VALUE",
        "customValue": "123 Roman Ave, Tampa, FL 33606"
      }
    }
  },
  "neighborhoodcallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167727/01a03517-f9fc-779e-bc1c-cc20f40fbb23.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment building exterior with balconies and palm trees."
      }
    }
  },
  "propertyoverview.image": {
    "sourceIndex": 43,
    "fieldOverrides": null
  },
  "propertyoverview.image_secondary": {
    "sourceIndex": 37,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "hero.slides": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_75af0a69958b8ec2d4d4dd5f",
      "ec_dab370bc8e926bbf25c57821",
      "ec_4c42a08ec851f7d4ceeb031f",
      "ec_73ef479172be8949c370aac4",
      "ec_67164d30f9a6805e4b733170",
      "ec_6ff55ba83c5ecae24dabf0ab",
      "ec_29f0e07a39a1373e0147999f",
      "ec_e78502e3783233541dfe381d",
      "ec_c40852848fcacebf41be877e",
      "ec_fd1d780209174ec8de092b0e",
      "ec_d85e8cd93c35668955c72c25",
      "ec_cde5374b5b86a28a44c7b892",
      "ec_d80a7146def4e72f0240ebae",
      "ec_62fdfa53a5e40bad4ae33aea",
      "ec_1b620288fbd00cb7d9ce47bb",
      "ec_e4a24b3cbc78b70d41340842",
      "ec_8ec0e4d7a76551b1ad592a8e",
      "ec_e747f40d6c756f14bb339217",
      "ec_121067d968c60026917663a4",
      "ec_d406860e3e589ad9be64cab9",
      "ec_ad869bbd5f4df0e968bd16f2",
      "ec_448e5e317a441b61e503482c",
      "ec_8840269d5cbf58f8fdf71f57",
      "ec_9cdb62e8d68df98c9f2102b4",
      "ec_1d6aece27e66b5df84cab49c",
      "ec_d7b2ec1071352d415aceb065",
      "ec_7375e71cfce2ae33b688c5e7",
      "ec_1bb09c7f7c6b40be730ee7b4",
      "ec_7307fa2eedc02074958473ed",
      "ec_330af27c01c980f173db2ef7",
      "ec_178a6b4f107b81d1d16f6310",
      "ec_ee6ae8b7d1edaec84acb13d6",
      "ec_a6145aeefd21363db9d9cb84",
      "ec_50daea3fb7ed8699ff20d737",
      "ec_59c62d4c3b7b3a8494f38d4b",
      "ec_d1616584094eea3c2b74cf8a",
      "ec_5a1570e9c25e9a7045b9d190",
      "ec_78886f6898bc81f327a8a6e0",
      "ec_b79d049b6f8ac5d0b4c8bf76",
      "ec_22faae9fcc7bff1adbf4711e",
      "ec_706529e255add4db8b7e734e",
      "ec_61d156f22cd5b99a1671351b",
      "ec_1d3d7427b2653be79e051e84",
      "ec_fdcc2fd639d3e7294b197d6a",
      "ec_30f8bdbdc3e0f533873e9ea9",
      "ec_38ccc249aac0d1e400ad6c00",
      "ec_aa57667fa9bfa5ad8f0f17fe",
      "ec_ca6ffe62d6bd3ff3bf7f5f60",
      "ec_5adb0685c3fb58141dad9215",
      "ec_fe2644c92419bda373c7289e",
      "ec_0d03ac576e4c7a44d5f5a0d3",
      "ec_acc4e5422f975395f74d70fa",
      "ec_3b3f532dc52e3a03931ae5c9",
      "ec_69c8c43ae16becd52f378334"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 4
    }
  ]
};

export const styleOverrides = {};
